import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CustomerDashboard = () => {
  const [personalTrainingUnlocked, setPersonalTrainingUnlocked] = useState(false); // Lock/Unlock state

  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12">Customer Dashboard</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
          {/* Attendance Card */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg" onClick={() => navigate('/customerattendance')}>
            <h3 className="text-2xl font-bold mb-4">Attendance</h3>
            <p className="mb-6 text-gray-400">Track your gym attendance and sessions here.</p>
            <button className="bg-yellow-400 text-gray-900 px-6 py-2 rounded-full font-semibold hover:bg-yellow-500 transition">
              View Attendance
            </button>
          </div>

          {/* Our Plan Card */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg" onClick={() => navigate('/customermyplan')}>
            <h3 className="text-2xl font-bold mb-4">My Plan</h3>
            <p className="mb-6 text-gray-400">View your current membership plan details.</p>
            <button className="bg-yellow-400 text-gray-900 px-6 py-2 rounded-full font-semibold hover:bg-yellow-500 transition">
              View Plan
            </button>
          </div>

          {/* Our Plan Card */}
          {/* <div className="bg-gray-800 p-6 rounded-lg shadow-lg" onClick={() => navigate('/customercoins')}>
            <h3 className="text-2xl font-bold mb-4">My Coins</h3>
            <p className="mb-6 text-gray-400">View your achievements in form of these coins.</p>
            <button className="bg-yellow-400 text-gray-900 px-6 py-2 rounded-full font-semibold hover:bg-yellow-500 transition">
              View Coins
            </button>
          </div> */}

          {/* Personal Training Card */}
          {/* <div className={`bg-gray-800 p-6 rounded-lg shadow-lg ${personalTrainingUnlocked ? '' : 'cursor-not-allowed opacity-50'}`}>
            <h3 className="text-2xl font-bold mb-4">Personal Training</h3>
            <p className="mb-6 text-gray-400">
              {personalTrainingUnlocked ? 'Access your personal training sessions.' : 'Unlock personal training with a purchase.'}
            </p>
            <button
              disabled={!personalTrainingUnlocked}
              className={`${
                personalTrainingUnlocked
                  ? 'bg-yellow-400 text-gray-900'
                  : 'bg-gray-600 text-gray-400 '
              } px-6 py-2 rounded-full font-semibold transition`}
            >
              {personalTrainingUnlocked ? 'Access Training' : 'Locked'}
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CustomerDashboard;
